import { clampTo, hasImageInput } from '../../tools';
import type { KieModelConfig } from '../types';

export const topazConfigs: Record<string, KieModelConfig> = {
    // https://kie.ai/topaz-image-upscale
    'topaz/image-upscale': {
        enableTranslation: false,
        buildInput: (params) => {
            const { image_urls, image_resolution } = params;
            const hasImage = hasImageInput(image_urls);
            if (!hasImage) {
                throw new Error('Missing Image Input');
            }
            return {
                model: 'topaz/image-upscale',
                input: {
                    image_url: image_urls[0],
                    upscale_factor: clampTo(image_resolution.replace('x', '') || '2', ['2', '4', '8'] as const, '2'),
                },
            };
        },
    },
};
